// This file is auto-generated by @hey-api/openapi-ts

import {
	type Options,
	getGameGamesGameIdGet,
	getGamesByStateGamesStateStateAbbrGet,
	getAllStatesStatesGet,
	getStateStatesAbbrGet,
	getLatestReportGamesGameIdReportsLatestGet,
	getReportsInRangeGamesGameIdReportsGet,
	rootGet,
	healthHealthGet,
	debugDbDebugDbGet
} from '../sdk.gen';
import { queryOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/svelte-query';
import type {
	GetGameGamesGameIdGetData,
	GetGamesByStateGamesStateStateAbbrGetData,
	GetGamesByStateGamesStateStateAbbrGetError,
	GetGamesByStateGamesStateStateAbbrGetResponse,
	GetAllStatesStatesGetData,
	GetStateStatesAbbrGetData,
	GetLatestReportGamesGameIdReportsLatestGetData,
	GetReportsInRangeGamesGameIdReportsGetData,
	GetReportsInRangeGamesGameIdReportsGetError,
	GetReportsInRangeGamesGameIdReportsGetResponse,
	RootGetData,
	HealthHealthGetData,
	DebugDbDebugDbGetData
} from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
	Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
		_id: string;
		_infinite?: boolean;
	}
];

const createQueryKey = <TOptions extends Options>(
	id: string,
	options?: TOptions,
	infinite?: boolean
): [QueryKey<TOptions>[0]] => {
	const params: QueryKey<TOptions>[0] = {
		_id: id,
		baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl
	} as QueryKey<TOptions>[0];
	if (infinite) {
		params._infinite = infinite;
	}
	if (options?.body) {
		params.body = options.body;
	}
	if (options?.headers) {
		params.headers = options.headers;
	}
	if (options?.path) {
		params.path = options.path;
	}
	if (options?.query) {
		params.query = options.query;
	}
	return [params];
};

export const getGameGamesGameIdGetQueryKey = (options: Options<GetGameGamesGameIdGetData>) =>
	createQueryKey('getGameGamesGameIdGet', options);

/**
 * Get Game
 */
export const getGameGamesGameIdGetOptions = (options: Options<GetGameGamesGameIdGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getGameGamesGameIdGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getGameGamesGameIdGetQueryKey(options)
	});
};

export const getGamesByStateGamesStateStateAbbrGetQueryKey = (
	options: Options<GetGamesByStateGamesStateStateAbbrGetData>
) => createQueryKey('getGamesByStateGamesStateStateAbbrGet', options);

/**
 * Get Games By State
 */
export const getGamesByStateGamesStateStateAbbrGetOptions = (
	options: Options<GetGamesByStateGamesStateStateAbbrGetData>
) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getGamesByStateGamesStateStateAbbrGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getGamesByStateGamesStateStateAbbrGetQueryKey(options)
	});
};

const createInfiniteParams = <
	K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>
>(
	queryKey: QueryKey<Options>,
	page: K
) => {
	const params = {
		...queryKey[0]
	};
	if (page.body) {
		params.body = {
			...(queryKey[0].body as any),
			...(page.body as any)
		};
	}
	if (page.headers) {
		params.headers = {
			...queryKey[0].headers,
			...page.headers
		};
	}
	if (page.path) {
		params.path = {
			...(queryKey[0].path as any),
			...(page.path as any)
		};
	}
	if (page.query) {
		params.query = {
			...(queryKey[0].query as any),
			...(page.query as any)
		};
	}
	return params as unknown as typeof page;
};

export const getGamesByStateGamesStateStateAbbrGetInfiniteQueryKey = (
	options: Options<GetGamesByStateGamesStateStateAbbrGetData>
): QueryKey<Options<GetGamesByStateGamesStateStateAbbrGetData>> =>
	createQueryKey('getGamesByStateGamesStateStateAbbrGet', options, true);

/**
 * Get Games By State
 */
export const getGamesByStateGamesStateStateAbbrGetInfiniteOptions = (
	options: Options<GetGamesByStateGamesStateStateAbbrGetData>
) => {
	return infiniteQueryOptions<
		GetGamesByStateGamesStateStateAbbrGetResponse,
		GetGamesByStateGamesStateStateAbbrGetError,
		InfiniteData<GetGamesByStateGamesStateStateAbbrGetResponse>,
		QueryKey<Options<GetGamesByStateGamesStateStateAbbrGetData>>,
		| number
		| Pick<
				QueryKey<Options<GetGamesByStateGamesStateStateAbbrGetData>>[0],
				'body' | 'headers' | 'path' | 'query'
		  >
	>(
		// @ts-ignore
		{
			queryFn: async ({ pageParam, queryKey, signal }) => {
				// @ts-ignore
				const page: Pick<
					QueryKey<Options<GetGamesByStateGamesStateStateAbbrGetData>>[0],
					'body' | 'headers' | 'path' | 'query'
				> =
					typeof pageParam === 'object'
						? pageParam
						: {
								query: {
									page: pageParam
								}
							};
				const params = createInfiniteParams(queryKey, page);
				const { data } = await getGamesByStateGamesStateStateAbbrGet({
					...options,
					...params,
					signal,
					throwOnError: true
				});
				return data;
			},
			queryKey: getGamesByStateGamesStateStateAbbrGetInfiniteQueryKey(options)
		}
	);
};

export const getAllStatesStatesGetQueryKey = (options?: Options<GetAllStatesStatesGetData>) =>
	createQueryKey('getAllStatesStatesGet', options);

/**
 * Get All States
 */
export const getAllStatesStatesGetOptions = (options?: Options<GetAllStatesStatesGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getAllStatesStatesGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getAllStatesStatesGetQueryKey(options)
	});
};

export const getStateStatesAbbrGetQueryKey = (options: Options<GetStateStatesAbbrGetData>) =>
	createQueryKey('getStateStatesAbbrGet', options);

/**
 * Get State
 */
export const getStateStatesAbbrGetOptions = (options: Options<GetStateStatesAbbrGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getStateStatesAbbrGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getStateStatesAbbrGetQueryKey(options)
	});
};

export const getLatestReportGamesGameIdReportsLatestGetQueryKey = (
	options: Options<GetLatestReportGamesGameIdReportsLatestGetData>
) => createQueryKey('getLatestReportGamesGameIdReportsLatestGet', options);

/**
 * Get Latest Report
 */
export const getLatestReportGamesGameIdReportsLatestGetOptions = (
	options: Options<GetLatestReportGamesGameIdReportsLatestGetData>
) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getLatestReportGamesGameIdReportsLatestGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getLatestReportGamesGameIdReportsLatestGetQueryKey(options)
	});
};

export const getReportsInRangeGamesGameIdReportsGetQueryKey = (
	options: Options<GetReportsInRangeGamesGameIdReportsGetData>
) => createQueryKey('getReportsInRangeGamesGameIdReportsGet', options);

/**
 * Get Reports In Range
 */
export const getReportsInRangeGamesGameIdReportsGetOptions = (
	options: Options<GetReportsInRangeGamesGameIdReportsGetData>
) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await getReportsInRangeGamesGameIdReportsGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: getReportsInRangeGamesGameIdReportsGetQueryKey(options)
	});
};

export const getReportsInRangeGamesGameIdReportsGetInfiniteQueryKey = (
	options: Options<GetReportsInRangeGamesGameIdReportsGetData>
): QueryKey<Options<GetReportsInRangeGamesGameIdReportsGetData>> =>
	createQueryKey('getReportsInRangeGamesGameIdReportsGet', options, true);

/**
 * Get Reports In Range
 */
export const getReportsInRangeGamesGameIdReportsGetInfiniteOptions = (
	options: Options<GetReportsInRangeGamesGameIdReportsGetData>
) => {
	return infiniteQueryOptions<
		GetReportsInRangeGamesGameIdReportsGetResponse,
		GetReportsInRangeGamesGameIdReportsGetError,
		InfiniteData<GetReportsInRangeGamesGameIdReportsGetResponse>,
		QueryKey<Options<GetReportsInRangeGamesGameIdReportsGetData>>,
		| number
		| Pick<
				QueryKey<Options<GetReportsInRangeGamesGameIdReportsGetData>>[0],
				'body' | 'headers' | 'path' | 'query'
		  >
	>(
		// @ts-ignore
		{
			queryFn: async ({ pageParam, queryKey, signal }) => {
				// @ts-ignore
				const page: Pick<
					QueryKey<Options<GetReportsInRangeGamesGameIdReportsGetData>>[0],
					'body' | 'headers' | 'path' | 'query'
				> =
					typeof pageParam === 'object'
						? pageParam
						: {
								query: {
									page: pageParam
								}
							};
				const params = createInfiniteParams(queryKey, page);
				const { data } = await getReportsInRangeGamesGameIdReportsGet({
					...options,
					...params,
					signal,
					throwOnError: true
				});
				return data;
			},
			queryKey: getReportsInRangeGamesGameIdReportsGetInfiniteQueryKey(options)
		}
	);
};

export const rootGetQueryKey = (options?: Options<RootGetData>) =>
	createQueryKey('rootGet', options);

/**
 * Root
 */
export const rootGetOptions = (options?: Options<RootGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await rootGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: rootGetQueryKey(options)
	});
};

export const healthHealthGetQueryKey = (options?: Options<HealthHealthGetData>) =>
	createQueryKey('healthHealthGet', options);

/**
 * Health
 */
export const healthHealthGetOptions = (options?: Options<HealthHealthGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await healthHealthGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: healthHealthGetQueryKey(options)
	});
};

export const debugDbDebugDbGetQueryKey = (options?: Options<DebugDbDebugDbGetData>) =>
	createQueryKey('debugDbDebugDbGet', options);

/**
 * Debug Db
 * Debug endpoint to check database connection and table status.
 */
export const debugDbDebugDbGetOptions = (options?: Options<DebugDbDebugDbGetData>) => {
	return queryOptions({
		queryFn: async ({ queryKey, signal }) => {
			const { data } = await debugDbDebugDbGet({
				...options,
				...queryKey[0],
				signal,
				throwOnError: true
			});
			return data;
		},
		queryKey: debugDbDebugDbGetQueryKey(options)
	});
};
